import FooterView from '../view/footer_view';
import {connect} from "react-redux";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { requestDataFromApp } from '../thunc/tunc';

function mapStateToProps(state:RootState){  
    const myprops=
    {
        version:state.footer.version,
    }
    return myprops;
}

function bindDispatchToActions(dispatch:Dispatch<any>){
    return {
            onLoadRequested:()=>{ 
                dispatch(requestDataFromApp() as any);
            },
    }
}

const FooterViewContainer=connect(mapStateToProps, bindDispatchToActions)(FooterView);
export default FooterViewContainer;